import { jsx as _jsx } from "react/jsx-runtime";
// @ts-ignore-next-line importsNotUsedAsValues
import 'react';
import BSOverlayTrigger from 'react-bootstrap/OverlayTrigger';
import omit from 'lodash/omit';
import { PLACEMENT } from '../../values/Placement';
import { TRIGGER } from '../../values/Trigger';
const OverlayTrigger = (props) => {
    const usedProps = Object.assign({ rootClose: true }, omit(props, 'children'));
    const { children } = props;
    // @ts-ignore
    return _jsx(BSOverlayTrigger, Object.assign({}, usedProps, { children: children }));
};
OverlayTrigger.TRIGGER_CLICK = TRIGGER.CLICK;
OverlayTrigger.TRIGGER_HOVER = TRIGGER.HOVER;
OverlayTrigger.TRIGGER_FOCUS = TRIGGER.FOCUS;
// placement
OverlayTrigger.AUTO_START = PLACEMENT.AUTO_START;
OverlayTrigger.AUTO = PLACEMENT.AUTO;
OverlayTrigger.AUTO_END = PLACEMENT.AUTO_END;
OverlayTrigger.TOP_START = PLACEMENT.TOP_START;
OverlayTrigger.TOP = PLACEMENT.TOP;
OverlayTrigger.TOP_END = PLACEMENT.TOP_END;
OverlayTrigger.RIGHT_START = PLACEMENT.RIGHT_START;
OverlayTrigger.RIGHT = PLACEMENT.RIGHT;
OverlayTrigger.RIGHT_END = PLACEMENT.RIGHT_END;
OverlayTrigger.BOTTOM_START = PLACEMENT.BOTTOM_START;
OverlayTrigger.BOTTOM = PLACEMENT.BOTTOM;
OverlayTrigger.BOTTOM_END = PLACEMENT.BOTTOM_END;
OverlayTrigger.LEFT_START = PLACEMENT.LEFT_START;
OverlayTrigger.LEFT = PLACEMENT.LEFT;
OverlayTrigger.LEFT_END = PLACEMENT.LEFT_END;
export default OverlayTrigger;
